/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react'
import { Control, FieldError, UseFormSetValue, useWatch } from 'react-hook-form'

import { Box, FormHelperText, OutlinedInput } from '@mui/material'

import { cpf as maskCpf } from '../../utils/mask'

type Props = {
  control: Control
  id: string
  label: string
  disabled?: boolean
  error: FieldError
  setValue: UseFormSetValue<any>
}

function CpfField(
  { control, id, label, disabled, error, setValue, ...props }: Props,
  ref: React.Ref<HTMLInputElement>
) {
  const cpf = useWatch({ control, name: id })

  useEffect(() => {
    if (!cpf) {
      return
    }
    const value = maskCpf(cpf)
    setValue(id, value)
  }, [id, cpf, setValue])

  return (
    <>
      <FormHelperText>{label}</FormHelperText>
      <OutlinedInput
        fullWidth
        ref={ref}
        id={id}
        readOnly={disabled}
        type="text"
        color="success"
        inputProps={{ maxLength: 14 }}
        {...props}
        error={!!error}
        className={disabled ? 'disabled-input' : ''}
      />
      <Box height={20}>
        <FormHelperText error>{error?.message}</FormHelperText>
      </Box>
    </>
  )
}

export default React.forwardRef(CpfField)
